<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Walkies Career Request
        </v-card-title>
        <page-loader :loading="isFetching" />
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.user_name"
                outlined
                readonly
                hide-details="auto"
                label="User Name"
                prepend-inner-icon="mdi-account"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.age"
                outlined
                readonly
                hide-details="auto"
                label="Age"
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone_no"
                outlined
                readonly
                hide-details="auto"
                label="Phone Number"
                prepend-inner-icon="mdi-phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.whatsapp_no"
                outlined
                readonly
                hide-details="auto"
                label="WhatsApp Number"
                prepend-inner-icon="mdi-whatsapp"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.area"
                outlined
                readonly
                hide-details="auto"
                label="Area"
                prepend-inner-icon="mdi-map-marker"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.pin_code"
                outlined
                readonly
                hide-details="auto"
                label="Pin Code"
                prepend-inner-icon="mdi-map-marker-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.preferred_timeslot"
                outlined
                readonly
                hide-details="auto"
                label="Preferred Timeslot"
                prepend-inner-icon="mdi-clock"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="experienceText"
                outlined
                readonly
                hide-details="auto"
                label="Is Experienced"
                prepend-inner-icon="mdi-star"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="internetAccessText"
                outlined
                readonly
                hide-details="auto"
                label="Has Internet Access"
                prepend-inner-icon="mdi-wifi"
              ></v-text-field>
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12">
              <v-autocomplete
                v-model="form.franchisee_id"
                outlined
                hide-details="auto"
                :items="franchiseeItems"
                :loading="isFranchiseeLoading"
                label="Franchisee (required to approve)"
                hint="The approved walker joins this franchisee as staff"
                persistent-hint
                clearable
                prepend-inner-icon="mdi-store"
                :error-messages="errors.franchisee_id"
              ></v-autocomplete>
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12">
              <v-autocomplete
                v-model="form.status"
                outlined
                hide-details="auto"
                :items="statusItems"
                label="Status"
                prepend-inner-icon="mdi-checkbox-marked-circle-outline"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn v-can:edit="'dog_walker_requests'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Walkies Career Request
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "PetWalkieCareerRequestEditPage",
  data() {
    return {
      form: {
        is_active: false,
      },
      franchiseeItems: [],
      isFranchiseeLoading: false,
      statusItems: [
        { id: "PENDING", text: "PENDING", value: 0 },
        { id: "APPROVED", text: "APPROVED", value: 1 },
        { id: "REJECTED", text: "REJECTED", value: 2 },
      ],
      isLoading: false,
      isFetching: false,
    };
  },
  computed: {
    experienceText() {
      return this.form.is_experienced ? "YES" : "NO";
    },
    internetAccessText() {
      return this.form.has_internet_access ? "YES" : "NO";
    },
  },
  async mounted() {
    this.isFetching = true;
    try {
      await this.getData();
      await this.getFranchisees();
    } finally {
      this.isFetching = false;
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.petWalkieCareerRequestId;
      axios
        .get(`/pet_walkie_career_requests/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async getFranchisees() {
      this.isFranchiseeLoading = true;
      try {
        const response = await axios.get("franchisees?is_active=1&status=1");
        this.franchiseeItems = (response.data.data || []).map((franchisee) => ({
          id: franchisee.id,
          text: `${franchisee.name} (${franchisee.email})`,
          value: franchisee.id,
        }));
      } catch (error) {
        console.error("Error fetching franchisees:", error);
      }
      this.isFranchiseeLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios
          .patch(
            `/pet_walkie_career_requests/${this.$route.params.petWalkieCareerRequestId}`,
            this.form,
          )
          .then(async () => {
            await this.saveUserTimestamp(this.old_json, this.form);
            this.$router.push("/pet-walkie-career-requests");
          })
          .catch((error) => {
            console.error(error);
            const status = error.response ? error.response.status : null;
            // 422 is the backend refusing an approval, e.g. no franchisee picked -
            // the admin has to see that instead of a session popup.
            if (status === 422) {
              const data = error.response.data || {};
              const first = data.errors
                ? Object.values(data.errors)[0]
                : data.message;
              this.isShowPopUP(
                "Cannot update request",
                Array.isArray(first) ? first[0] : first
              );
              return;
            }
            this.isUnAuthorised();
          });
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
